import { FC, useContext, useState } from 'react';
import { SDKContext } from '../context/sdk';

type AsyncDesignCallback = (design: any) => Promise<any>;

type DABProps = { onClick: AsyncDesignCallback }

/**
 * This can take any of the same props as 
 * the design-system button.
 * However, the `onClick` callback receives the
 * currently loaded design for ease of use.
 */
const DesignActionButton: FC<DABProps> = ({
  children,
  onClick,
  ...props
}) => {
  const [actionPending, setActionPending] = useState(false);

  const { error, design } = useContext(SDKContext);
  const disabled = Boolean(!design || error);

  return (
      <button
        style={{ minWidth: '24ch' }}
        disabled={disabled || actionPending}
        {...props}
        onClick={async () => {
          setActionPending(true);
          await onClick(design);

          setActionPending(false);
        }}
      >
        {children}
      </button>
  );
}

export default DesignActionButton;